import apiClient from './client';

// ─── Stammbäume (Mandanten) ─────────────────────────────────────────────────

export interface Tree {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  personCount: number;
  memberCount: number;
  /** Besitzt der angemeldete Betreiber diesen Baum selbst? Meist false. */
  isOwner: boolean;
  /** Wem der Baum gehört. null, wenn kein Besitzer eingetragen ist. */
  owner: { userId: string; email: string } | null;
}

export interface TreeInput {
  name: string;
  description?: string | null;
}

/** Bäume, auf die der angemeldete Nutzer Zugriff hat (Admins: alle). */
export async function listTrees(): Promise<Tree[]> {
  const { data } = await apiClient.get<{ data: Tree[] }>('/trees');
  return data.data;
}

export async function createTree(input: TreeInput): Promise<Tree> {
  const { data } = await apiClient.post<Tree>('/trees', input);
  return data;
}

export async function updateTree(id: string, input: Partial<TreeInput>): Promise<Tree> {
  const { data } = await apiClient.patch<Tree>(`/trees/${id}`, input);
  return data;
}

/** Löscht einen Stammbaum samt Inhalt – erfordert das Bestätigungswort. */
export async function deleteTree(id: string): Promise<void> {
  await apiClient.delete(`/trees/${id}`, { data: { confirm: 'LÖSCHEN' } });
}

/**
 * Weist den Besitz zu – Eingriff des Betreibers.
 *
 * Für den Normalfall gibt es die Übergabe in der Anwendung, die der Besitzer
 * selbst auslöst. Diese Route ist für den Fall, dass niemand mehr an den Baum
 * kommt. Das Konto muss nicht Mitglied sein; die Mitgliedschaft entsteht dabei.
 */
export async function setTreeOwner(treeId: string, userId: string): Promise<void> {
  await apiClient.put(`/trees/${treeId}/owner`, { userId });
}
